import { createSelector } from '@ngrx/store';

import { OfferKind, TalentPoolBrief, TalentPoolStatus } from '@recruitee/http/types';
import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TalentPoolBrief>()(
  'TalentPoolsNewBrief',
  {
    customActions: adapter => ({
      references: (state, payload: { data: TalentPoolBrief[] }) => {
        const entities = payload.data.map(entity => ({
          ...entity,
          kind: OfferKind.TalentPool,
        }));
        return adapter.updateOrCreateMany(state, entities);
      },
    }),
  },
);

const TalentPoolsNewBriefSelectors = {
  ...selectors,
  default: memoizeSelector(() =>
    createSelector(selectors.entities(), entities =>
      entities.filter(entity => entity.status === TalentPoolStatus.Default),
    ),
  ),
  archived: memoizeSelector(() =>
    createSelector(selectors.entities(), entities =>
      entities.filter(entity => entity.status === TalentPoolStatus.Archived),
    ),
  ),
};

export {
  TalentPoolsNewBriefSelectors,
  actions as TalentPoolsNewBriefActions,
  reducer as TalentPoolsBriefReducer,
  namespace as TalentPoolsBriefNamespace,
};
